export const EDITOR_THEME_CONTENT_TEXT_COLOR_COMMAND = 'mceApplyTextcolor'

export const EDITOR_THEME_CONTENT_TEXT_COLOR_FORMAT = 'forecolor'
